import { on } from '../../js/dom';

const DEAL_PAGE_RE = /(?:^|https?:\/\/[^/]+)?\/deals\/(view|tasks|users|files|activity|match|companymatch|invoices|invoice|settings|quotes|ldr|filelandingpage|exportnotes|exportquote)\/id\/(\d+)(?:[/?#]|$)/i;
const INVOICE_EDIT_RE = /(?:^|https?:\/\/[^/]+)?\/invoices\/(\d+)\/edit(?:[/?#]|$)/i;

function paywallEnabled() {
	return window.checkForAccess === 'enabled';
}

function closestDealId(el) {
	const withAttr = el.closest('[data-deal-access-id]');
	if (withAttr) {
		const id = parseInt(withAttr.getAttribute('data-deal-access-id'), 10);
		return id > 0 ? id : null;
	}
	return null;
}

function dealIdFromHref(href) {
	if (!href || href === '#') {
		return null;
	}
	const dealMatch = href.match(DEAL_PAGE_RE);
	if (dealMatch) {
		return parseInt(dealMatch[2], 10);
	}
	return null;
}

function shouldSkip(el) {
	return Boolean(el.closest('[data-deal-access-skip="true"]'));
}

function wantsNewTab(event, el) {
	if (event.button === 1 || event.metaKey || event.ctrlKey || event.shiftKey) {
		return true;
	}

	return el.tagName === 'A' && el.getAttribute('target') === '_blank';
}

function openPaywall(dealId, url, newTab) {
	if (!dealId || typeof window.Livewire === 'undefined' || typeof window.Livewire.dispatch !== 'function') {
		return;
	}
	window.Livewire.dispatch('openRequestDealAccess', {
		dealId: dealId,
		url: url || null,
		newTab: Boolean(newTab),
	});
}

function interceptEvent(event) {
	if (!paywallEnabled()) {
		return;
	}
	if (event.defaultPrevented) {
		return;
	}

	const el = event.target && event.target.closest ? event.target.closest('a[href], [data-deal-access-id]') : null;
	if (!el || shouldSkip(el)) {
		return;
	}

	let dealId = closestDealId(el);
	if (!dealId && el.tagName === 'A') {
		dealId = dealIdFromHref(el.getAttribute('href'));
	}

	if (!dealId) {
		return;
	}

	if (el.tagName === 'A' && INVOICE_EDIT_RE.test(el.getAttribute('href') || '') && !closestDealId(el)) {
		return;
	}

	if (typeof window.Livewire === 'undefined' || typeof window.Livewire.dispatch !== 'function') {
		return;
	}

	event.preventDefault();
	event.stopPropagation();
	openPaywall(dealId, el.tagName === 'A' ? el.href : null, wantsNewTab(event, el));
}

document.addEventListener('click', interceptEvent, true);
document.addEventListener('auxclick', interceptEvent, true);

on(document, 'click', '[data-deal-access-action]', function (e, el) {
	const action = el.getAttribute('data-deal-access-action');
	const notificationId = el.getAttribute('data-notification-id');
	const requestId = parseInt(el.getAttribute('data-request-id'), 10);
	if (!action || !notificationId || !requestId) {
		return;
	}
	if (typeof window.Livewire === 'undefined' || typeof window.Livewire.dispatch !== 'function') {
		return;
	}

	e.preventDefault();

	// Block a second click while the first response is still in flight.
	const actions = el.closest('[data-deal-access-actions]');
	if (actions) {
		actions.querySelectorAll('[data-deal-access-action]').forEach(function (button) {
			button.disabled = true;
		});
	}

	window.Livewire.dispatch('respondDealAccess', {
		notificationId: notificationId,
		requestId: requestId,
		action: action,
	});
});

function resolveDealAccessActions(requestId, label) {
	if (!requestId) {
		return;
	}
	const selector = '[data-deal-access-actions="' + requestId + '"]';
	document.querySelectorAll(selector).forEach(function (actions) {
		const resolved = document.createElement('span');
		resolved.className = 'deal-access-notification__resolved';
		resolved.textContent = label || 'Resolved';
		actions.replaceChildren(resolved);

		const expiry = actions.parentElement
			? actions.parentElement.querySelector('.deal-access-notification__expiry')
			: null;
		if (expiry) {
			expiry.remove();
		}
	});
}

function reenableDealAccessActions(requestId) {
	if (!requestId) {
		return;
	}
	const selector = '[data-deal-access-actions="' + requestId + '"] [data-deal-access-action]';
	document.querySelectorAll(selector).forEach(function (button) {
		button.disabled = false;
	});
}

function onLivewireReady(callback) {
	if (window.Livewire && typeof window.Livewire.on === 'function') {
		callback();

		return;
	}
	document.addEventListener('livewire:init', callback, { once: true });
}

function livewirePayload(payload) {
	return Array.isArray(payload) ? payload[0] : payload;
}

onLivewireReady(function () {
	window.Livewire.on('deal-access-responded', function (payload) {
		const data = livewirePayload(payload);
		if (!data) {
			return;
		}
		resolveDealAccessActions(parseInt(data.requestId, 10), data.label);
	});

	window.Livewire.on('deal-access-response-failed', function (payload) {
		const data = livewirePayload(payload);
		if (!data) {
			return;
		}
		reenableDealAccessActions(parseInt(data.requestId, 10));
	});
});

if (typeof window.jQuery !== 'undefined') {
	window.jQuery(document).ajaxError(function (_event, xhr) {
		if (!paywallEnabled() || !xhr || xhr.status !== 403) {
			return;
		}
		const dealId = xhr.responseJSON && xhr.responseJSON.deal_id;
		if (dealId) {
			openPaywall(dealId);
		}
	});
}
